/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_UnlimitedInputs */

const fr_plan_choice_unlimited = /** @type {(inputs: Plan_Choice_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances illimitées`)
};

/**

* @param {Plan_Choice_UnlimitedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_unlimited = /** @type {((inputs?: Plan_Choice_UnlimitedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_UnlimitedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_unlimited(inputs)
});